import React, { Component } from 'react';
import { Layout, Collapse, Icon, Table, Row, Col, Form, DatePicker, Input, Select, Button, Spin, Modal, Checkbox, Radio, Upload, Cascader, Tabs, Card, List } from 'antd';
import { FormattedMessage, useIntl, injectIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { filter, last, find, includes } from 'lodash';
import { toUpperKey } from '../../../../../util/helpper';
import moment from 'moment';
import './Checklist.css';
import ScrollToTop from '../../../../../components/ScrollToTop';
import MenuSider from '../../../../../components/MenuSider';
import IntlMessages from '../../../../../util/IntlMessages';
import DateTimeFormat from '../../../../../Constants/DateTimeFormat';
import { Odata_Url, Constants } from '../../../../../Constants/Constants';
import Local from '../../../../../Constants/Local';

const { Panel } = Collapse;
const { Content } = Layout;
const { Column } = Table;
const { RangePicker } = DatePicker;
const { Option } = Select;
const CheckboxGroup = Checkbox.Group;
const RadioGroup = Radio.Group;
const FormItem = Form.Item;
const TabPane = Tabs.TabPane;

function getBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}

class Checklist extends Component {

    constructor(prop) {
        super(prop);

        this.state = {
            jobTypeModalVisible: false,
            jobType_TypeSelected: undefined,
            jobType_GroupNameSelected: undefined,
            jobTypeIdSelectedTmp: undefined,
            attachFilePreviewVisible: false,
            attachFilePreviewUrl: undefined,
            jobOtherDetail: '',
            isSubmit:false,
        }
    }

    componentDidMount() { }

    validate = () => {

        const result = {
            isPass: true,
            msg: ""
        };

        console.debug("this.props.optCategorySelecteds", this.props.optCategorySelecteds);

        if (!this.props.optCategorySelecteds || this.props.optCategorySelecteds.length === 0) {
            result.isPass = false;
            result.msg = this.props.intl.formatMessage({ id: 'Checklist.job_observed_2' }) + " !";
        }
        if (this.state.jobType_GroupNameSelected == "งานอื่นๆ" && !this.props.observationTrn.jobOtherDetail) {
            result.isPass = false;
            result.msg = "Please specify detail !";
            this.setState({ isSubmit: true });
        }

        return result;
    }

    setSelectedJobType = (jobType_Type, jobType_GroupName) => {
        this.setState({
            jobType_TypeSelected: jobType_Type,
            jobType_GroupNameSelected: jobType_GroupName,
        });
    }

    btnOpenJobTypeModalClick = () => {
        const jobTypeGroupOfFactorys = this.props.jobTypeGroupOfFactorys;
        const jobTypeGroupOfOffices = this.props.jobTypeGroupOfOffices;

        let jobType_TypeSelected = this.state.jobType_TypeSelected;
        let jobType_GroupNameSelected = this.state.jobType_GroupNameSelected;

        if (!jobType_TypeSelected) {
            jobType_TypeSelected = "factory";
        }

        if (!jobType_GroupNameSelected) {
            if (jobType_TypeSelected === "factory") {
                if (jobTypeGroupOfFactorys && jobTypeGroupOfFactorys.length > 0) {
                    jobType_GroupNameSelected = jobTypeGroupOfFactorys[0].groupNameTh;
                }
            }
            else {
                if (jobTypeGroupOfOffices && jobTypeGroupOfOffices.length > 0) {
                    jobType_GroupNameSelected = jobTypeGroupOfOffices[0].groupNameTh;
                }
            }
        }
        console.log(jobType_GroupNameSelected)
        this.setState({
            jobType_TypeSelected: jobType_TypeSelected,
            jobType_GroupNameSelected: jobType_GroupNameSelected,
            jobTypeIdSelectedTmp: this.props.observationTrn.jobTypeID,
            jobTypeModalVisible: true
        });
    }

    onJobType_TypeChange = (jobType_TypeSelected) => {
        const jobTypeGroupOfFactorys = this.props.jobTypeGroupOfFactorys;
        const jobTypeGroupOfOffices = this.props.jobTypeGroupOfOffices;
        const jobTypeIdSelectedTmp = this.state.jobTypeIdSelectedTmp;
        let jobType_GroupNameSelected = this.state.jobType_GroupNameSelected;

        if (jobTypeIdSelectedTmp) {
            const jobDataSelected = find(this.props.jobTypeDatas, (jobType) => {
                return jobType.PKJobTypeID === jobTypeIdSelectedTmp;
            });
            if (jobDataSelected) {
                if (jobDataSelected.Type !== jobType_TypeSelected) {
                    if (jobType_TypeSelected === "factory") {
                        if (jobTypeGroupOfFactorys && jobTypeGroupOfFactorys.length > 0) {
                            jobType_GroupNameSelected = jobTypeGroupOfFactorys[0].groupNameTh;
                        }
                    }
                    else {
                        if (jobTypeGroupOfOffices && jobTypeGroupOfOffices.length > 0) {
                            jobType_GroupNameSelected = jobTypeGroupOfOffices[0].groupNameTh;
                        }
                    }
                }
                else {
                    jobType_GroupNameSelected = jobDataSelected.GroupName;
                }
            }
            else {
                if (jobType_TypeSelected === "factory") {
                    if (jobTypeGroupOfFactorys && jobTypeGroupOfFactorys.length > 0) {
                        jobType_GroupNameSelected = jobTypeGroupOfFactorys[0].groupNameTh;
                    }
                }
                else {
                    if (jobTypeGroupOfOffices && jobTypeGroupOfOffices.length > 0) {
                        jobType_GroupNameSelected = jobTypeGroupOfOffices[0].groupNameTh;
                    }
                }
            }
        }
        else {
            if (jobType_TypeSelected === "factory") {
                if (jobTypeGroupOfFactorys && jobTypeGroupOfFactorys.length > 0) {
                    jobType_GroupNameSelected = jobTypeGroupOfFactorys[0].groupNameTh;
                }
            }
            else {
                if (jobTypeGroupOfOffices && jobTypeGroupOfOffices.length > 0) {
                    jobType_GroupNameSelected = jobTypeGroupOfOffices[0].groupNameTh;
                }
            }
        }

        
        this.setState({
            jobType_TypeSelected: jobType_TypeSelected,
            jobType_GroupNameSelected: jobType_GroupNameSelected,
        });
    }

    onJobType_GroupNameChange = (jobType_GroupName) => {
        this.setState({
            jobType_GroupNameSelected: jobType_GroupName
        });
    }

    onSelectedJobTypeClick = (jobType) => {
        this.setState({
            jobTypeIdSelectedTmp: jobType.PKJobTypeID,
        });
    }

    onCategoryChange = (checked, optCategory) => {
        this.props.onCategoryChange(checked, optCategory);
    }

    onConfirmJobTypeSelected = (e) => {
        const jobIdSelected = this.state.jobTypeIdSelectedTmp;

        this.setState({
            jobTypeIdSelectedTmp: undefined,
            jobTypeModalVisible: false,
        }, () => {

            const $setIsLoading = this.props.setIsLoading(true);
            const $getTokenHeader = this.getTokenHeader();

            Promise.all([$setIsLoading, $getTokenHeader]).then(([_, tokenHeader]) => {

                const jobDataSelected = find(this.props.jobTypeDatas, (jobType) => {
                    return jobType.PKJobTypeID === jobIdSelected;
                });

                axios(Odata_Url + "OJobType_Category?$filter=IsActived eq true and JobTypeId eq " + jobIdSelected, tokenHeader).then((jobTypeCategoryDataResp) => {
                    const jobTypeCategoryDatas = jobTypeCategoryDataResp.data.value;
                    const categoryIds = jobTypeCategoryDatas.map(item => item.CatId);

                    const categoryDataForThisTypes = filter(this.props.categoryDatas, { Type_Category: this.state.jobType_TypeSelected });
                    const optCategories = filter(categoryDataForThisTypes, (cat) => {
                        return includes(categoryIds, cat.PKCategoryID);
                    });

                    //optCategories.forEach(optCat => {
                    //    optCat.checked = false;
                    //    optCat.detail = undefined;
                    //    if (optCat.subCategories) {
                    //        optCat.subCategories.forEach(optSubCat => {
                    //            optSubCat.unSafe = undefined;
                    //        });
                    //    }
                    //});

                    optCategories.forEach(optCat => {
                        let foundItem = find(this.props.optCategorySelecteds, catSelected => {
                            return optCat.PKCategoryID === catSelected.PKCategoryID;
                        });

                        if (!foundItem) {
                            optCat.checked = false;
                            optCat.detail = undefined;
                            if (optCat.subCategories) {
                                optCat.subCategories.forEach(optSubCat => {
                                    optSubCat.unSafe = undefined;
                                });
                            }
                        }
                    });

                    const optCategorySelecteds = [];

                    if (this.props.optCategorySelecteds) {
                        this.props.optCategorySelecteds.forEach(catSelected => {
                            let foundItem = find(optCategories, optCate => {
                                return optCate.PKCategoryID === catSelected.PKCategoryID;
                            });

                            if (foundItem) {
                                optCategorySelecteds.push(catSelected);
                            }
                        });
                    }

                    console.debug("onConfirmJobTypeSelected", {
                        optCategories: optCategories,
                        optCategorySelecteds: optCategorySelecteds,
                        optCategoryUnSafes: this.props.optCategoryUnSafes,
                    });

                    this.props.setOptCategories(optCategories);
                    this.props.setOptCategorySelecteds(optCategorySelecteds);
                    //this.props.setOptCategoryUnSafes([]);
                    this.props.setObservationTrnFields([
                        { value: jobIdSelected, fieldName: "jobTypeID" },
                        { value: jobDataSelected, fieldName: "jobTypeData" },
                    ]);

                    this.props.setIsLoading(false);
                });
            });
        });
    };

    onCancelJobTypeSelected = e => {
        console.log(e);
        this.setState({
            jobTypeIdSelectedTmp: undefined,
            jobTypeModalVisible: false,
        });
    };
    onChangeDetail = (element, type) => {
        this.props.setObservationTrnField(element, type);
    }
    handleAttachFilePreview = async (file) => {
        let url = "";

        if (file.url) {
            url = file.url;
        }
        else {
            url = await getBase64(file.originFileObj);
        }

        this.setState({
            attachFilePreviewUrl: url,
            attachFilePreviewVisible: true,
        });
    };

    handleAttachFileChange = (e) => {
        const observationTrnAttachments = [];
        e.fileList.forEach(file => {
            observationTrnAttachments.push(file);
        });
        this.props.setObservationTrnAttachments(observationTrnAttachments);
    };

    handleAttachFileCancel = () => {
        this.setState({
            attachFilePreviewUrl: undefined,
            attachFilePreviewVisible: false
        });
    };

    getTokenHeader = () => {
        var $getToken = new Promise((resolve, reject) => {
            axios.get('auth/token').then((res) => {
                const tokenHeader = { headers: { "Authorization": "Bearer " + res.data } };
                resolve(tokenHeader);
            }).catch(err => {
                if (401 === err.response.status) {
                    localStorage.setItem("ObsReqRedirectAfterLogin", "ObsReqRedirectAfterLogin");
                    window.location.href = "auth";
                }
                reject(err);
            });
        });
        return $getToken;
    }

    render() {
        const view = this.props.isReadonly
        const local = this.props.intl ? this.props.intl.locale : Local.TH;
        const optCategories = this.props.optCategories ? this.props.optCategories : [];
        const observationTrn = this.props.observationTrn ? this.props.observationTrn : {};
        const observationTrnAttachments = this.props.observationTrnAttachments ? this.props.observationTrnAttachments : [];
        const jobTypeGroupOfFactorys = this.props.jobTypeGroupOfFactorys ? this.props.jobTypeGroupOfFactorys : [];
        const jobTypeGroupOfOffices = this.props.jobTypeGroupOfOffices ? this.props.jobTypeGroupOfOffices : [];
      
        return (<Card size="small">

            {observationTrn.jobTypeID ? (<>
                <Row>
                    <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                        <IntlMessages id="Checklist.job_observed" />&nbsp;&nbsp;
                        <Button type="default" style={{ height: "64px" }}>
                            <img alt={observationTrn.jobTypeData.Image_name} src={"images/" + observationTrn.jobTypeData.Image_name} style={{ width: "48px" }}/>&nbsp;
                            {local === Local.TH ? observationTrn.jobTypeData.Short_detail : observationTrn.jobTypeData.Short_detail_EN}
                        </Button>&nbsp;&nbsp;
                        <Button size="large" disabled={view} style={{ color: "#fff", background: "rgb(231, 0, 7)", border: "none" }} onClick={this.btnOpenJobTypeModalClick}>Edit</Button>
                    </Col>
                    
                </Row>
                <Row>
                    <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Form.Item label="Detail" validateStatus={this.state.isSubmit && !observationTrn.jobOtherDetail ? "error" : "success"}>
                            <Input
                                disabled={view}
                                value={observationTrn.jobOtherDetail}
                                onChange={element => this.onChangeDetail(element.target.value, "jobOtherDetail")}
                            />

                        </Form.Item>
                    </Col>
                </Row>
                <br /><br />
                <List bordered={true}>
                    {optCategories.map((optCategory) => {
                        return (<List.Item key={optCategory.PKCategoryID}>
                            <Checkbox checked={optCategory.checked} disabled={view} onChange={(e) => this.onCategoryChange(e.target.checked, optCategory)}>
                                <img src={"images/" + optCategory.Image_name} style={{ width: "40px", filter: "grayscale(100%)" }} />&nbsp;&nbsp;
                                <span>{local === Local.TH ? optCategory.Category_Name : optCategory.Category_Name_EN}</span>
                            </Checkbox>
                        </List.Item>);
                    })}
                </List>
            </>) : (<>
                <IntlMessages id="Checklist.job_observed_2" />
                <br /><br />
                <Button size="large" style={{ color: "#fff", background: "rgb(231, 0, 7)", border: "none" }} onClick={this.btnOpenJobTypeModalClick}>Select</Button>
            </>
            )}
            <br/>
            <Row>
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                    <br />
                    <div className="clearfix">
                        <Upload
                            beforeUpload={(file) => {
                                return false;
                            }}
                            listType="picture-card"
                            fileList={observationTrnAttachments}
                            onPreview={this.handleAttachFilePreview}
                            onChange={this.handleAttachFileChange}
                            disabled={view}
                        >
                            {observationTrnAttachments.length >= 8 ? null : <div>
                                <Icon type="plus" />
                                <div className="ant-upload-text">Upload</div>
                            </div>}
                        </Upload>
                        <Modal visible={this.state.attachFilePreviewVisible} footer={null} onCancel={this.handleAttachFileCancel}>
                            <img alt="example" style={{ width: '100%' }} src={this.state.attachFilePreviewUrl} />
                        </Modal>
                    </div>
                </Col>
            </Row>
            
            <Modal
                width="90%"
                title="Please select job type"
                visible={this.state.jobTypeModalVisible}
                onOk={this.onConfirmJobTypeSelected}
                onCancel={this.onCancelJobTypeSelected}
            >
                <Tabs style={{ marginLeft: "2px", marginRight: "2px" }}
                    activeKey={this.state.jobType_TypeSelected}
                    onChange={this.onJobType_TypeChange}>
                    <TabPane tab={<span><Icon type="setting" />Factory</span>} key="factory" tabBarStyle={{ width: "50%" }}>
                        <br />
                        <Tabs activeKey={this.state.jobType_GroupNameSelected}
                            type='card' size='small' tabPosition='left'
                            className="job-type-group-tabs"
                            onChange={this.onJobType_GroupNameChange}
                        >
                            {jobTypeGroupOfFactorys.map((jobTypeGroupOfFactory) => {
                                return (<TabPane tab={local === Local.TH ? jobTypeGroupOfFactory.groupNameTh : jobTypeGroupOfFactory.groupNameEn} key={jobTypeGroupOfFactory.groupNameTh}>
                                    <Row>
                                        {jobTypeGroupOfFactory.jobTypes.map((jobType) => {

                                            let jobTypeClassName = "job-type-card";
                                            if (jobType.PKJobTypeID === this.state.jobTypeIdSelectedTmp) {
                                                jobTypeClassName += " job-type-card-selected";
                                            }

                                            return (<Col xs={8} sm={8} md={6} lg={4} xl={3} xxl={2} key={jobType.PKJobTypeID} className="job-type-col">
                                                <Button type="link" onClick={() => { this.onSelectedJobTypeClick(jobType); }}>
                                                    <Card
                                                        className={jobTypeClassName}
                                                        hoverable
                                                        cover={<img alt={jobType.Image_name} src={"images/" + jobType.Image_name} />}
                                                    >
                                                        <Card.Meta title={local === Local.TH ? jobType.Short_detail : jobType.Short_detail_EN} />
                                                    </Card>
                                                </Button>

                                            </Col>);
                                        })}
                                    </Row>
                                </TabPane>);
                            })}
                        </Tabs>
                    </TabPane>
                    <TabPane tab={<span><Icon type="home" />Office</span>} key="office" tabBarStyle={{ width: "50%" }}>
                        <br />
                        <Tabs activeKey={this.state.jobType_GroupNameSelected}
                            type='card' size='small' tabPosition='left'
                            className="job-type-group-tabs"
                            onChange={this.onJobType_GroupNameChange}
                        >
                            {jobTypeGroupOfOffices.map((jobTypeGroupOfOffice) => {
                                return (<TabPane tab={local === Local.TH ? jobTypeGroupOfOffice.groupNameTh : jobTypeGroupOfOffice.groupNameEn} key={jobTypeGroupOfOffice.groupNameTh}>
                                    <Row>
                                        {jobTypeGroupOfOffice.jobTypes.map((jobType) => {

                                            let jobTypeClassName = "job-type-card";
                                            if (jobType.PKJobTypeID === this.state.jobTypeIdSelectedTmp) {
                                                jobTypeClassName += " job-type-card-selected";
                                            }

                                            return (<Col xs={8} sm={8} md={6} lg={4} xl={3} xxl={2} key={jobType.PKJobTypeID} className="job-type-col">
                                                <Button type="link" onClick={() => { this.onSelectedJobTypeClick(jobType); }}>
                                                    <Card
                                                        className={jobTypeClassName}
                                                        hoverable
                                                        cover={<img alt={jobType.Image_name} src={"images/" + jobType.Image_name} />}
                                                    >
                                                        <Card.Meta title={local === Local.TH ? jobType.Short_detail : jobType.Short_detail_EN} />
                                                    </Card>
                                                </Button>

                                            </Col>);
                                        })}
                                    </Row>
                                </TabPane>);
                            })}
                        </Tabs>
                    </TabPane>
                </Tabs>
            </Modal>
        </Card>);
    }

}

export default injectIntl(Checklist, { withRef: true });